// extracted by mini-css-extract-plugin
module.exports = {"layout":"A4_18_Labels_layout__29S23"};